//Lt. Cdr. Data
export const getData = state => (state.table.data);
export const getSorted = state => (state.table.sorted);
export const getPage = state => (state.table.page);
export const getPages = state => (state.table.pages);
export const getPageSize = state => (state.table.pageSize);
export const getExpanded = state => (state.table.expanded);
export const getResized = state => (state.table.resized);
export const getFiltered = state => (state.table.filtered);
export const getLoading = state => (state.table.loading);
export const getTableState = state => (state.table);
export const getKeyword= state => (state.table.keyword);
